export interface IsalIrrigationPlanInfo {
    description: string;
    duration: number;
    euids: string[];
    startOn: string;
    wateringRig: string;
    release: boolean;
    releaseOption: IsalReleaseOptions;
}

export enum IsalReleaseOptions{
    Forecast = "Forecast",
    Release = "Released"
}